module.exports = __webpack_public_path__ + "62093ab307741bf28dd68ab0c766dad5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/2.jpg
// module id = 1346
// module chunks = 47